module.exports = __webpack_public_path__ + "static/painel_loft-81e587045d2d22679d42431109334847.jpg";